import type { Currency } from '@/types/api'
import { createCrudService } from '../crud'

export type CurrencyInput = Pick<Currency, 'code' | 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'icon' | 'is_base' | 'is_active'>

export const currenciesService = createCrudService<Currency, CurrencyInput>('currencies', { updateMethod: 'patch' })
